export default __webpack_public_path__ + "static/media/capgemini-logo.b3ea2f22.png";